var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg-blue-800 h-full w-full" }, [
      _c(
        "div",
        { staticClass: "container mx-auto px-4 h-full pt-24 min-h-screen" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex content-center items-center justify-center h-full"
            },
            [
              _c("div", { staticClass: "w-full lg:w-7/12 px-4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-100 border-0"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-auto px-4 lg:px-10 py-10 pt-0" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "h6",
                          {
                            staticClass: "font-bold text-center mb-8 text-3xl"
                          },
                          [_vm._v("Thank you!")]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n                We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link."
                          ),
                          _c("br"),
                          _c("br"),
                          _vm._v(
                            "\n                If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form."
                          ),
                          _c("br"),
                          _c("br"),
                          _vm._v(
                            "\n                If you still didn't receive the confirmation email to "
                          ),
                          _c("span", { staticClass: "font-bold" }, [
                            _vm._v(_vm._s(this.email))
                          ]),
                          _vm._v(" , click "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-blue-600 cursor-pointer font-bold",
                              on: { click: _vm.nextProcess }
                            },
                            [_vm._v("here")]
                          ),
                          _vm._v(" to resend.\n              ")
                        ]),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _vm.error
                          ? _c(
                              "alert",
                              {
                                staticClass: "mt-4",
                                attrs: { variant: "danger" }
                              },
                              [
                                _vm._v(
                                  "\n                Sorry! " +
                                    _vm._s(_vm.error) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.isEmailHasBeenSend
      ? _c(
          "div",
          {
            staticClass:
              "fixed top-0 mt-8 w-full p-2 md:p-0 flex justify-center",
            on: {
              click: function($event) {
                return _vm.toggleToast()
              }
            }
          },
          [
            _c("input", {
              staticClass: "hidden",
              attrs: { type: "checkbox", id: "footertoast" }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "close cursor-pointer flex items-start justify-between w-full md:w-1/2  p-2 bg-green-500 rounded shadow-lg text-white",
                attrs: { title: "close", for: "footertoast" }
              },
              [
                _vm._v("\n      Email has been sent\n\n      "),
                _c(
                  "svg",
                  {
                    staticClass: "fill-current text-white",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: " mb-3" }, [
      _c("img", {
        staticClass: "m-auto",
        staticStyle: { width: "150px" },
        attrs: { src: require("@/assets/musicverse-logo.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-left mt-6" }, [
      _vm._v(
        "\n                Your artist application has been submitted and is now "
      ),
      _c("span", { staticClass: "font-bold" }, [
        _vm._v("pending admin review")
      ]),
      _vm._v(
        ". Once you verify your email, our team will review your application and follow up with the next steps.\n              "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fdc32fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fdc32fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SignupSuccess.vue
// module id = null
// module chunks = 